{
  "familyId": "GET-MACHT",
  "questions": [
    {
      "id": "GET-MACHT-001",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een wetenschapper noteert een aantal als $2^3$. Een leerling leest dit als '2 × 3'. Welk antwoord laat zien wat er fout gaat en geeft de juiste waarde?",
      "options": [
        "$2^3$ = 2 × 2 × 2 = 8 (drie keer 2 vermenigvuldigen, niet 2 × 3)",
        "$2^3$ = 2 + 2 + 2 = 6 (de exponent zegt hoe vaak je optelt)",
        "$2^3$ = 2 × 3 = 6 (de leerling heeft gelijk)",
        "$2^3$ = 3 × 3 = 9 (de exponent is het grondtal)"
      ],
      "correctAnswer": 0,
      "conceptId": "power_notation_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Machtsverheffing", "content": "$a^n$ = a × a × a … (n keer). Het grondtal (a) wordt n keer met zichzelf vermenigvuldigd.", "icon": "lightbulb" } }],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.macht-als-optellen", "label": "Verwart machtsverheffen met optellen", "optionIndex": 1 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent i.p.v. herhaald vermenigvuldigen", "optionIndex": 2 },
          { "id": "get.exponent-als-grondtal", "label": "Verwisselt grondtal en exponent", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling maakt de meest voorkomende denkfout: hij leest $2^3$ als '2 keer 3'. Maar het kleine getal rechtsboven (de exponent) telt hoe vaak je het grondtal met zichzelf vermenigvuldigt. Dus $2^3$ = 2 × 2 × 2 = 8, niet 2 × 3 = 6. Bij $2^3$ is 2 het grondtal en 3 de exponent: je doet drie tweeën keer elkaar.",
        "solutionSteps": [
          "Grondtal = onderste getal (hier 2), exponent = bovenste getal (hier 3)",
          "Exponent zegt: hoe vaak vermenigvuldig je het grondtal met zichzelf?",
          "$2^3$ = 2 × 2 × 2",
          "2 × 2 = 4, dan × 2 = 8"
        ],
        "distractorExplanations": {
          "0": "Goed! De leerling deed 2 × 3, maar $2^3$ = 2 × 2 × 2 = 8.",
          "1": "Optellen ≠ machtsverheffen. 2 + 2 + 2 = 6 hoort niet bij $2^3$. Bij een macht vermenigvuldig je.",
          "2": "Dit is precies de denkfout van de leerling. $2^3$ ≠ 2 × 3. De exponent vertelt hoe vaak je vermenigvuldigt.",
          "3": "Bij $2^3$ is 2 het grondtal, niet 3. Het onderste getal is het grondtal, het kleine getal rechtsboven is de exponent."
        }
      }
    },
    {
      "id": "GET-MACHT-002",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "fill_in",
      "question": "Bereken: $3^4$ = ? Typ alleen het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["81"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Stap-voor-stap", "content": "$3^4$ = 3 × 3 × 3 × 3. Reken in stappen: 3 × 3 = 9, 9 × 3 = 27, 27 × 3 = 81.", "icon": "lightbulb" } }],
      "conceptId": "power_compute_3to4",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "$3^4$ betekent: vier keer het grondtal 3 met zichzelf vermenigvuldigen — niet 3 × 4. Reken stap voor stap, telkens × 3: 3 × 3 = 9, dan 9 × 3 = 27, dan 27 × 3 = 81. Antwoord: 81.",
        "solutionSteps": ["3 × 3 = 9", "9 × 3 = 27", "27 × 3 = 81", "Antwoord: 81"]
      }
    },
    {
      "id": "GET-MACHT-003",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een ingenieur berekent het oppervlak van een vierkant met zijde 3 cm. Welke berekening hoort erbij?",
      "options": ["$3^2$ = 9 cm²", "3 × 2 = 6 cm²", "3 + 3 = 6 cm²", "$2^3$ = 8 cm²"],
      "correctAnswer": 0,
      "conceptId": "power_square_context",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 3,
            "mode": "power"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Kwadraat = oppervlak van vierkant", "content": "Oppervlak vierkant = zijde × zijde = zijde². Dus 3 × 3 = $3^2$ = 9 cm².", "icon": "lightbulb" } }],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.opp-als-zijde-keer-2", "label": "Doet zijde × 2 i.p.v. zijde × zijde", "optionIndex": 1 },
          { "id": "met.opp-als-omtrek", "label": "Telt zijden op (deel van omtrek)", "optionIndex": 2 },
          { "id": "get.exponent-als-grondtal", "label": "Verwisselt grondtal en exponent", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Oppervlak van een vierkant = zijde × zijde = zijde². Dus 3 × 3 = $3^2$ = 9 cm². Vandaar de naam 'kwadraat' — hoort bij vierkanten.",
        "solutionSteps": ["Oppervlak vierkant = zijde × zijde", "3 × 3 = $3^2$", "$3^2$ = 9 cm²"],
        "distractorExplanations": {
          "0": "Goed! Het oppervlak van een vierkant is zijde × zijde, dus $3^2$ = 3 × 3 = 9 cm².",
          "1": "Zijde × 2 is geen oppervlak. Oppervlak = zijde × zijde.",
          "2": "3 + 3 = 6 zijn twee zijden, dat is een deel van de omtrek, niet het oppervlak.",
          "3": "Je hebt grondtal en exponent verwisseld. Hier is de zijde 3 (grondtal), de exponent 2."
        }
      }
    },
    {
      "id": "GET-MACHT-004",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een programmeur verdubbelt data elke dag. Na 4 dagen is de hoeveelheid $2^4$ keer zo groot. Hoeveel is dat?",
      "options": ["16", "8", "6", "32"],
      "correctAnswer": 0,
      "conceptId": "power_context_doubling",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Verdubbeling als macht", "content": "Elke dag ×2. Na 4 dagen: 2 × 2 × 2 × 2 = $2^4$ = 16.", "icon": "lightbulb" } }],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.exponent-met-1-vermindert", "label": "Rekent met exponent − 1 (= $2^3$)", "optionIndex": 1 },
          { "id": "get.macht-als-optellen", "label": "Telt grondtal + exponent op", "optionIndex": 2 },
          { "id": "get.exponent-met-1-verhoogt", "label": "Rekent met exponent + 1 (= $2^5$)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "$2^4$ betekent: vier keer 2 met elkaar vermenigvuldigen. Reken stapsgewijs op zoals de verdubbelingen elke dag: dag 1 levert 2 op, dag 2 verdubbelt dat tot 4, dag 3 wordt 8, dag 4 wordt 16. Dus $2^4$ = 2 × 2 × 2 × 2 = 16.",
        "solutionSteps": ["$2^4$ = 2 × 2 × 2 × 2", "2 × 2 = 4 → × 2 = 8 → × 2 = 16"],
        "distractorExplanations": {
          "0": "Goed! Na 4 verdubbelingen is de hoeveelheid 16 keer zo groot: 2 × 2 × 2 × 2 = $2^4$ = 16.",
          "1": "Dat is $2^3$ = 8. Eén verdubbeling te weinig — je hebt dag 4 gemist.",
          "2": "Optellen ≠ machtsverheffen. $2^4$ ≠ 2 + 4 = 6. Bij een macht vermenigvuldig je.",
          "3": "Dat is $2^5$ = 32. Eén verdubbeling te veel — na dag 4 stop je. Na 4 dagen: 2 × 2 × 2 × 2 = 16, niet 32."
        }
      }
    },
    {
      "id": "GET-MACHT-005",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "fill_in",
      "question": "Een astronoom schrijft het getal als macht van 10. Bereken: $10^5$ = ? Typ het getal zonder punten of komma's, of met punten als duizendtalsteken.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["100000", "100.000"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Machten van 10", "content": "$10^n$ = 1 gevolgd door n nullen. $10^5$ = 100.000 (5 nullen).", "icon": "lightbulb" } }],
      "conceptId": "power_ten_compute",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "$10^5$ = 10 × 10 × 10 × 10 × 10 = 100.000. Bij machten van 10 geldt een handige truc: de exponent telt het aantal nullen achter de 1. Dus $10^5$ schrijf je als 1 met 5 nullen erachter: 100.000.",
        "solutionSteps": ["$10^n$ = 1 met n nullen", "$10^5$ = 1 met 5 nullen", "Antwoord: 100.000"]
      }
    },
    {
      "id": "GET-MACHT-006",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een wiskundige stelt: $2^4$ en $4^2$ geven hetzelfde antwoord. Klopt dat?",
      "options": ["Ja, beide zijn 16", "Nee, $2^4$ is groter", "Nee, $4^2$ is groter", "Dat hangt ervan af"],
      "correctAnswer": 0,
      "conceptId": "power_compare_reasoning",
      "variantIndex": 6,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "size": 4,
            "mode": "power"
          }
        }
      ],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Bereken altijd beide", "content": "$2^4$ = 16. $4^2$ = 16. Dit is een toevallige uitzondering — meestal is omdraaien wél verschillend.", "icon": "lightbulb" } }],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.hogere-exponent-altijd-groter", "label": "Denkt dat hogere exponent altijd groter is", "optionIndex": 1 },
          { "id": "get.groter-grondtal-altijd-groter", "label": "Denkt dat groter grondtal altijd groter is", "optionIndex": 2 },
          { "id": "get.machten-niet-vergelijkbaar", "label": "Denkt dat je machten niet kunt vergelijken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "$2^4$ = 16 en $4^2$ = 16. Dit is een toeval — meestal geeft het omdraaien een ander antwoord (bv. $2^5$ = 32 maar $5^2$ = 25). Reken altijd uit.",
        "solutionSteps": ["$2^4$ = 2 × 2 × 2 × 2 = 16", "$4^2$ = 4 × 4 = 16", "16 = 16 → even groot (toevallig)"],
        "distractorExplanations": {
          "0": "Goed! Beide = 16.",
          "1": "Niet altijd. Bij ($2^4$, $4^2$) zijn ze gelijk.",
          "2": "Niet altijd. Bij ($2^4$, $4^2$) zijn ze gelijk.",
          "3": "Je kunt machten áltijd uitrekenen en vergelijken."
        }
      }
    },
    {
      "id": "GET-MACHT-007",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "true_false_series",
      "question": "Beoordeel elke uitspraak.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "$5^2$ = $2^5$.", "isTrue": false },
          { "text": "$1^{100}$ = 1.", "isTrue": true },
          { "text": "$10^3$ = 1.000.", "isTrue": true },
          { "text": "$3^2$ = 6.", "isTrue": false },
          { "text": "$0^5$ = 0.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Bijzondere machten", "content": "$1^n$ blijft altijd 1. $0^n$ (n>0) is altijd 0. $a^2$ ≠ $2a$ — bereken altijd uit.", "icon": "lightbulb" } }],
      "conceptId": "power_tf_series",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "$5^2$=25, $2^5$=32 → niet gelijk → ONWAAR. $1^{100}$=1 (1 blijft 1) → WAAR. $10^3$=1.000 → WAAR. $3^2$=9, niet 6 → ONWAAR. $0^5$=0×0×0×0×0=0 → WAAR.",
        "solutionSteps": [
          "$5^2$ = 25, $2^5$ = 32 → ONWAAR",
          "$1^{100}$ = 1 (1 keer met zichzelf blijft 1) → WAAR",
          "$10^3$ = 1.000 → WAAR",
          "$3^2$ = 9, niet 6 → ONWAAR",
          "$0^5$ = 0 → WAAR"
        ]
      }
    },
    {
      "id": "GET-MACHT-008",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "matching",
      "question": "Koppel elke macht aan zijn waarde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "$2^5$", "right": "32" },
          { "left": "$3^3$", "right": "27" },
          { "left": "$5^2$", "right": "25" },
          { "left": "$10^2$", "right": "100" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Reken stap voor stap", "content": "$2^5$ = 2×2×2×2×2 = 32. $3^3$ = 27. $5^2$ = 25. $10^2$ = 100.", "icon": "lightbulb" } }],
      "conceptId": "power_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Reken elke macht stap voor stap uit door het grondtal herhaald met zichzelf te vermenigvuldigen. $2^5$ = 2×2×2×2×2 = 32. $3^3$ = 3×3×3 = 27. $5^2$ = 5×5 = 25. $10^2$ = 10×10 = 100. Koppel daarna elke macht aan de juiste waarde.",
        "solutionSteps": ["$2^5$ = 2×2×2×2×2 = 32", "$3^3$ = 3×3×3 = 27", "$5^2$ = 5×5 = 25", "$10^2$ = 10×10 = 100"]
      }
    },
    {
      "id": "GET-MACHT-009",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "ordering",
      "question": "Zet deze machten op volgorde van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["$3^2$", "$2^4$", "$5^2$", "$2^3$"],
        "correctOrder": [3, 0, 1, 2]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Eerst uitrekenen, dan sorteren", "content": "$3^2$=9, $2^4$=16, $5^2$=25, $2^3$=8. Sorteer dan: 8, 9, 16, 25.", "icon": "lightbulb" } }],
      "conceptId": "power_ordering",
      "variantIndex": 9,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Reken eerst uit: $2^3$=8, $3^2$=9, $2^4$=16, $5^2$=25. Volgorde: $2^3$ → $3^2$ → $2^4$ → $5^2$.",
        "solutionSteps": ["$3^2$ = 9", "$2^4$ = 16", "$5^2$ = 25", "$2^3$ = 8", "Sorteer: 8 < 9 < 16 < 25"]
      }
    },
    {
      "id": "GET-MACHT-010",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "fill_in",
      "question": "Welke exponent maakt deze gelijkheid waar? $2^? = 64$. Typ alleen het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tel hoe vaak je verdubbelt", "content": "Verdubbel vanaf 1: 2 → 4 → 8 → 16 → 32 → 64. Dat zijn 6 verdubbelingen, dus $2^6$ = 64.", "icon": "lightbulb" } }],
      "conceptId": "power_inverse_find_exponent",
      "variantIndex": 10,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Verdubbel stapsgewijs: 2, 4, 8, 16, 32, 64. Dat zijn 6 stappen, dus $2^6$ = 64.",
        "solutionSteps": [
          "$2^1$ = 2",
          "$2^2$ = 4",
          "$2^3$ = 8",
          "$2^4$ = 16",
          "$2^5$ = 32",
          "$2^6$ = 64 ✓",
          "Antwoord: 6"
        ]
      }
    }
  ]
}